import styled from 'styled-components'
import { IBurger } from './Burger'

const BORDER_SIZE_NUMBER = 1.5
const BORDER_SIZE = `${BORDER_SIZE_NUMBER}rem`

export const StyledBurgerWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const StyledBurgerText = styled.button<IBurger>`
  color: ${props => props.theme.colors.info[500]};
  background-color: transparent;
  padding: 0;
  margin-right: ${props => props.theme.spacing.default};
`

export const StyledBurger = styled.button<IBurger>`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  width: ${BORDER_SIZE};
  height: ${BORDER_SIZE};
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;

  &:focus {
    outline: none;
  }

  div {
    width: ${BORDER_SIZE};
    height: 2px;
    background: ${props => props.theme.colors.info[500]};
    border-radius: 10px;
    transition: all 0.3s linear;
    position: relative;
    transform-origin: 1px;

    :first-child {
      transform: ${({ open }) => (open ? 'rotate(45deg)' : 'rotate(0)')};
    }

    :nth-child(2) {
      opacity: ${({ open }) => (open ? '0' : '1')};
      transform: ${({ open }) => (open ? `translateX(${`${BORDER_SIZE_NUMBER / 2}rem`})` : 'translateX(0)')};
    }

    :nth-child(3) {
      transform: ${({ open }) => (open ? 'rotate(-45deg)' : 'rotate(0)')};
    }
  }
`
